/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: authorizationCodesActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Class of Services module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteAuthorizationCodeById as deleteApi } from './api';

/**
 * Shared helpers for Authorization Codes module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate an Authorization Code in the form.
 * Pattern: /pbx/class-of-service/auth-codes/new?duplicate={id}
 */
export const getAuthorizationCodeDuplicateUrl = (id: string | number): string =>
  `/pbx/class-of-service/auth-codes/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Authorization Code id.
 */
export const navigateToAuthorizationCodeDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getAuthorizationCodeDuplicateUrl(id));
};

/**
 * Low-level API helper to delete an Authorization Code by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 */
export const deleteAuthorizationCodeById = async (
  id: string | number,
  tenantSlug?: string,
): Promise<void> => {
  await deleteApi(id, tenantSlug);
};



